import classes from './WithTooltip.module.scss';
import React, { cloneElement, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { isFunction } from 'utils/common';
import { useTooltip } from 'hooks/useTooltip';

function WithTooltip({
  children,
  className,
  placement = 'top',
  modifiers = [],
  text,
  light,
  isVisible
}) {
  let ref = useRef();
  let popper = useRef();
  let { isTooltipVisible } = useTooltip(ref, popper, {
    placement,
    modifiers
  });

  useEffect(() => {
    if (isFunction(isVisible)) {
      isVisible(isTooltipVisible);
    }
  }, [isTooltipVisible, isVisible]);

  return (
    <>
      {cloneElement(children, { ref })}
      {isTooltipVisible &&
        createPortal(
          <div
            id="with-tooltip"
            ref={popper}
            className={cn(classes.container, className, {
              [classes.light]: light
            })}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
}

WithTooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(['top', 'top-start', 'top-end', 'bottom', 'left']),
  modifiers: PropTypes.array,
  light: PropTypes.bool,
  className: PropTypes.string,
  isVisible: PropTypes.func
};

export default WithTooltip;
